import { render } from "./rqzjView.vue?vue&type=template&id=06942232"
import script from "./rqzjView.vue?vue&type=script&lang=js"
export * from "./rqzjView.vue?vue&type=script&lang=js"

import "./rqzjView.vue?vue&type=style&index=0&id=06942232&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__